export function setLoggedIn(username) {
    return {type: 'SET_LOGGED_IN', payload: {username}}
}

export function logout() {
    return {type: 'LOG_OUT', payload: null}
}

export function setCompany(company) {
    return {type: 'SET_COMPANY', payload: company}
}

export function setTalentUser(tu) {
    // The reducer reads payload.user, so the profile must stay wrapped.
    return {type: 'SET_TALENT_USER', payload: {user: tu}}
}

export function setLanguage(language) {
    return {type: 'SET_LANGUAGE', payload: language}
}